
import feedbackFormReducer from './contactUs.reducer';

export default feedbackFormReducer;

